module.exports = __webpack_public_path__ + "img/content-img-4.60b43b61.jpg";